"use client";

import { useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[error.tsx]", error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <AlertTriangle className="size-10 text-amber-500" aria-hidden />
      <h2 className="text-title-2">Algo deu errado nesta página</h2>
      <p className="max-w-md text-sm text-muted-foreground">
        {error.message || "Erro inesperado no client. Tente recarregar."}
      </p>
      {error.digest && (
        <p className="font-mono text-xs text-muted-foreground">ID: {error.digest}</p>
      )}
      <Button onClick={() => reset()} variant="outline" className="mt-2">
        Tentar novamente
      </Button>
    </div>
  );
}
